import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { DataSource } from "@angular/cdk/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { UserdeleteComponent } from "../userdelete/userdelete.component";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { decryptData } from "src/app/services/aes.service";

@Component({
  selector: "app-apigrouplist",
  templateUrl: "./apigrouplist.component.html",
  styleUrls: ["./apigrouplist.component.scss"],
})
export class ApigrouplistComponent implements OnInit {
  groupList: any;
  dataSource: any;
  private paginator: MatPaginator;
  displayedcolumns: string[] = ["Sno", "name", "edit", "delete"];
  pageIndex: number;
  pageSize: number;
  length: number;
  pageEvent: PageEvent;
  loader = false;

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    // this.setDataSourceEntity();
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    private daoService: DaoService,
    private fb: FormBuilder,
    private router: Router,
    private token: LstorageService,
    private spinner: SpinnerService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    debugger;
    this.pageIndex = this.token.getpageIndex() ? +this.token.getpageIndex() : 0;
    this.pageSize = this.token.getpageSize() ? +this.token.getpageSize() : 10;
    //  this.length =  this.token.getpagelength() ? +this.token.getpagelength():10;

    this.spinner.show();
    this.daoService.getGroupList().subscribe(
      (data: any) => {
        let message = JSON.parse(decryptData(data.key));
        this.daoService.defaultGroupList(message);
        this.daoService.finalApiGroupList.subscribe(
          (groupList) => (this.groupList = groupList)
        );
        this.spinner.hide();
        this.dataSource = new MatTableDataSource(this.groupList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = function (
          data,
          filter: string
        ): boolean {
          return data.name.toLowerCase().includes(filter);
        };
      },
      (error) => {
        this.spinner.hide();
        console.log("Error:" + error);
      }
    );
  }

  public apiGroupFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  };

  createGroup() {
    this.token.apiGroupclear();
    this.router.navigate(["/ApiGroupForm"]);
  }
  editapiGroup(id) {
    this.token.saveGroupId(id);
    this.router.navigate(["/ApiGroupForm"]);
  }

  deleteGroup(id) {
    this.daoService.defaultApigroupId(id);
    this.daoService.groupDelete(true);
    const dialogRef = this.dialog.open(UserdeleteComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.groupDelete(false);
      this.daoService.finalApiGroupList.subscribe(
        (groupList) => (this.groupList = groupList)
      );
      this.dataSource = new MatTableDataSource(this.groupList);
      this.daoService.defaultApigroupId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  //For store pagination details
  public handlePage(e: any) {
    this.token.savepageIndex(e.pageIndex);
    this.token.savepageSize(e.pageSize);
    this.token.savepagelength(e.length);
    this.pageIndex = +this.token.getpageIndex();
    this.pageSize = +this.token.getpageSize();
    this.length = +this.token.getpagelength();
  }
}
